// Import main application code
import 'react-widgets/dist/css/react-widgets.css';
import '../javascript/common';

// Import CSS
import '../stylesheets/application.css';
